import type { Locale } from "./locales";
const english = { unavailable: "This check is temporarily unavailable.", retry: "Try again", correct: "Correct.", incorrect: "Not quite. The answer is", fullQuiz: "Try the full topic quiz" };
const mandarin = { unavailable: "目前无法加载此题。", retry: "重试", correct: "答对了。", incorrect: "未答对。正确答案是", fullQuiz: "练习完整主题测验" };
export function quickCheckCopy(locale: Locale = "en") {
  return locale === "zh-Hans" ? mandarin : english;
}
